import Linkify from "linkify-react";

import Image     from "_components/atoms/image";
import useStyles from "_styles/molecules/pinnedComment";

const component = props => {
	const {
		text,
		emotesList,
		isReadMore
	} = props;

	if ( !text )
		return null;

	const { classes }       = useStyles ();
	const searchEmotesRegex = /:([^:]{1,15}):/;

	const parseEmotes = () => {
		return text.split ( searchEmotesRegex ).map ( ( elem, i ) => {
			if ( !elem )
				return null;

			if ( i !== 0 && !emotesList[elem] )
				return `:${ elem }`;

			if ( !emotesList[elem] )
				return elem;

			return (
				<div
					key       = { i }
					className = { classes.emoteContainer }
				>
					<Image
						useOriginal
						className = { classes.emote }
						quality   = { 100 }
						src       = { emotesList[elem].url }
					/>
				</div>
			);
		} );
	};

	if ( text.split ( searchEmotesRegex ).length < 1 ) {
		return parseEmotes ();
	}

	if ( isReadMore )
		return parseEmotes ();

	return (
		<Linkify options = { { target: "_blank", className: "linkify" } }>
			{parseEmotes ()}
		</Linkify>
	);
};

export default component;
